import { render, staticRenderFns } from "./AllowancesTable.vue?vue&type=template&id=8a28fdce&"
import script from "./AllowancesTable.vue?vue&type=script&lang=js&"
export * from "./AllowancesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports